const SESSION_MESSAGE_TYPE = {
  img: '[图片]',
  file: '[文件]',
  audio: '[语音]',
  loc: '[位置]',
  goods: '[商品]',
  backlist: '[回收记录]',
  order: '[订单]',
  b_backlist: '[回收记录]',
  info: '[提示信息]',
  kefu_card: '[客服名片]',
  upload_qrCode: '[上传二维码]',
  settlementPush: '[卖家填写损耗]',
  allSettlement: '[卖家填写损耗]',
  midwaySettlement: '[卖家填写中途结算]',
  settlementPushBuyer: '[买家确认损耗]',
  productApply: '[捆绑包结算确认]',
  auto_return: '[常见问题]',
  boostSettleResult: '[买家已确认结算]',
}

const CUSTOM_TYPE = {
  image: '[图片]',
  sticker: '[表情包]',
  audio: '[语音]',
  video: '[视频]',
  file: '[文件]',
  goods: '[商品]',
  backlist: '[回收记录]',
  b_backlist: '[回收记录]',
  info: '[提示信息]',
  order: '[订单]',
  inform: '[系统通知]',
  kefu_card: '[客服名片]',
  upload_qrCode: '[上传二维码]',
  settlementPush: '[卖家填写损耗]',
  allSettlement: '[卖家填写损耗]',
  midwaySettlement: '[卖家填写中途结算]',
  settlementPushBuyer: '[买家确认损耗]',
  productApply: '[捆绑包结算确认]',
  auto_return: '[常见问题]',
  boostSettleResult: '[买家已确认结算]',
}
const ALL_MESSAGE_TYPE = {
  TEXT: 'txt',
  IMAGE: 'img',
  AUDIO: 'audio',
  LOCAL: 'loc',
  VIDEO: 'video',
  FILE: 'file',
  CUSTOM: 'custom',
  CMD: 'cmd',
  INFORM: 'inform', //这个类型不在环信消息类型内，属于自己定义的一种系统通知类的消息。
  GOODS: 'goods',
  BACKLIST: 'backlist',
  B_BACKLIST: 'b_backlist',
  ORDER: 'order',
}
const CHAT_TYPE = {
  SINGLE: 'singleChat',
  GROUP: 'groupChat',
}

export default {
  SESSION_MESSAGE_TYPE,
  CUSTOM_TYPE,
  ALL_MESSAGE_TYPE,
  CHAT_TYPE,
}
